'use client'

import { IconSustainability } from 'icons/components/IconSustainability'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import styles from './Sustainability.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface SustainabilityProps {
	readonly className?: string
	readonly hideLabel?: boolean
}
export function Sustainability({
	className,
	hideLabel = false,
}: SustainabilityProps) {
	const { t } = useLabels()
	return (
		<span
			className={cx(styles.sustainability, className)}
			data-testid='myPurchases.online.details.returns.sustainable'
		>
			<IconSustainability color='semantic-success' />
			{!hideLabel && (
				<span className={`${styles.text} ${text.textBodyS}`}>
					{t('myPurchases.online.details.returns.sustainable.label')}
				</span>
			)}
		</span>
	)
}
